/**
 * GTFS taban harita teması — Carto vektör (anahtarsız, Montserrat glyph'li).
 * Açık: Positron, koyu: Dark Matter. Referans katman renkleri temaya göre.
 */
import {
  CARTO_VECTOR_DARK_STYLE_URL,
  CARTO_VECTOR_POSITRON_STYLE_URL,
} from '@/config/cartoBasemap.js'

export const MAP_THEMES = Object.freeze({ light: 'light', dark: 'dark' })

/** Carto glyph sunucusundaki yazı ailesi (taban stil ile aynı) */
export const MAP_FONT_REGULAR = ['Montserrat Regular', 'Noto Sans Regular']
export const MAP_FONT_MEDIUM = ['Montserrat Medium', 'Noto Sans Regular']

/** Sadeleştirme: kalabalık yapan taban katmanları gizlenir */
const MUTED_BASE_LAYERS = [
  'housenumber',
  'poi_stadium',
  'poi_park',
  'building-top',
]

export const THEME_PAINT = Object.freeze({
  light: Object.freeze({
    background: '#f3f4f1',
    stopFill: '#ffffff',
    stopNeutral: '#475569',
    routeCasing: '#ffffff',
    labelText: '#1e293b',
    labelHalo: 'rgba(255, 255, 255, 0.95)',
    populationFill: '#475569',
    populationStroke: '#ffffff',
    baseIlceLine: 'rgba(71, 85, 105, 0.42)',
    baseMahalleLine: 'rgba(100, 116, 139, 0.2)',
    baseFill: 'rgba(15, 23, 42, 0)',
    selectedLine: '#0f172a',
    selectedFill: 'rgba(15, 23, 42, 0.06)',
    hoverLine: 'rgba(15, 23, 42, 0.45)',
  }),
  dark: Object.freeze({
    background: '#1b1c20',
    stopFill: '#ffffff',
    stopNeutral: '#cbd5e1',
    routeCasing: '#16171b',
    labelText: '#e5e7eb',
    labelHalo: 'rgba(15, 23, 42, 0.92)',
    populationFill: '#94a3b8',
    populationStroke: '#1e293b',
    baseIlceLine: 'rgba(186, 220, 255, 0.34)',
    baseMahalleLine: 'rgba(186, 220, 255, 0.12)',
    baseFill: 'rgba(158, 207, 255, 0)',
    selectedLine: 'rgba(226, 240, 255, 0.95)',
    selectedFill: 'rgba(196, 228, 255, 0.1)',
    hoverLine: 'rgba(196, 228, 255, 0.6)',
  }),
})

let activeTheme = MAP_THEMES.light

export function normalizeMapTheme(theme) {
  return theme === MAP_THEMES.dark ? MAP_THEMES.dark : MAP_THEMES.light
}

export function setActiveMapTheme(theme) {
  activeTheme = normalizeMapTheme(theme)
  return activeTheme
}

export function getActiveMapTheme() {
  return activeTheme
}

export function themePaint(theme = activeTheme) {
  return THEME_PAINT[normalizeMapTheme(theme)]
}

export function basemapStyleUrl(theme = activeTheme) {
  return normalizeMapTheme(theme) === MAP_THEMES.dark
    ? CARTO_VECTOR_DARK_STYLE_URL
    : CARTO_VECTOR_POSITRON_STYLE_URL
}

/** Taban stil yüklendikten sonra gürültülü katmanları kapat */
export function muteBasemap(map) {
  if (!map?.getLayer) return
  for (const id of MUTED_BASE_LAYERS) {
    if (!map.getLayer(id)) continue
    try {
      map.setLayoutProperty(id, 'visibility', 'none')
    } catch {
      /* ignore */
    }
  }
}

/**
 * setStyle sırasında GTFS (ge-*) kaynak ve katmanlarını yeni tabana taşır.
 */
export function carryOverGtfsLayers(prev, next) {
  if (!prev || !next) return next
  const sources = { ...(next.sources || {}) }
  for (const [id, src] of Object.entries(prev.sources || {})) {
    if (id.startsWith('ge-')) sources[id] = src
  }
  const layers = [
    ...(next.layers || []),
    ...(prev.layers || []).filter((l) => String(l.id || '').startsWith('ge-')),
  ]
  return { ...next, sources, layers }
}
